import { createContext } from "react"

export const RegexValidationContext = createContext<string | null>(null)
